import { projectService } from '@/services'
import { Project } from '@/types'
import { NodeInviteForm } from '@/components/nodes/NodeInviteForm'
import {
  createPermissionChecker,
  createUserExistsChecker,
  createMemberChecker,
  createAddMemberFunction,
  createRolePermissionsComponent,
} from '@/lib/factories/invite-factories'

export default function ProjectInvitePage() {
  return (
    <NodeInviteForm<Project>
      nodeType="project"
      nodeIdParam="projectId"
      getNodeById={projectService.getById.bind(projectService)}
      canInviteCheck={createPermissionChecker('project')}
      userExistsCheck={createUserExistsChecker('project')}
      isMemberCheck={createMemberChecker('project')}
      addMember={createAddMemberFunction('project', projectService)}
      getRolePermissions={createRolePermissionsComponent('project')}
      description="Invite a workspace member to join this project by entering their email address"
    />
  )
}
